import { useState } from 'react';

export interface ComponentItem {
  id: string;
  name: string;
  icon: string;
  category: string;
  defaultProps: Record<string, unknown>;
}

export const componentLibrary: ComponentItem[] = [
  // Layout
  { id: 'container', name: 'Container', icon: 'ri-layout-line', category: 'Layout', defaultProps: { padding: 16, backgroundColor: '#FFFFFF', borderRadius: 0 } },
  { id: 'row', name: 'Row', icon: 'ri-layout-row-line', category: 'Layout', defaultProps: { gap: 8, justifyContent: 'flex-start', padding: 8 } },
  { id: 'spacer', name: 'Spacer', icon: 'ri-space', category: 'Layout', defaultProps: { height: 16 } },
  { id: 'divider', name: 'Divider', icon: 'ri-separator', category: 'Layout', defaultProps: { color: '#E5E7EB', thickness: 1 } },
  // UI
  { id: 'button', name: 'Button', icon: 'ri-cursor-line', category: 'UI', defaultProps: { text: 'Tap Here', backgroundColor: '#14B8A6', textColor: '#FFFFFF', borderRadius: 8, fullWidth: true } },
  { id: 'text', name: 'Text', icon: 'ri-text', category: 'UI', defaultProps: { content: 'Your text here', fontSize: 16, color: '#111827', fontWeight: 'normal', align: 'left' } },
  { id: 'heading', name: 'Heading', icon: 'ri-heading', category: 'UI', defaultProps: { content: 'Heading', fontSize: 24, color: '#111827', fontWeight: 'bold', align: 'left' } },
  { id: 'image', name: 'Image', icon: 'ri-image-line', category: 'UI', defaultProps: { src: 'https://public.readdy.ai/ai/img_res/509692cf86889688318d1247fd98a831.jpg', alt: 'Image', borderRadius: 8, height: 160 } },
  { id: 'icon', name: 'Icon', icon: 'ri-star-line', category: 'UI', defaultProps: { iconName: 'ri-star-fill', size: 28, color: '#F59E0B' } },
  { id: 'badge', name: 'Badge', icon: 'ri-price-tag-3-line', category: 'UI', defaultProps: { text: 'New', backgroundColor: '#14B8A6', textColor: '#FFFFFF' } },
  { id: 'card', name: 'Card', icon: 'ri-layout-cards-line', category: 'UI', defaultProps: { title: 'Card Title', subtitle: 'Card description goes here', backgroundColor: '#FFFFFF', shadow: true } },
  { id: 'avatar', name: 'Avatar', icon: 'ri-user-3-line', category: 'UI', defaultProps: { initials: 'JD', backgroundColor: '#14B8A6', size: 48 } },
  { id: 'rating', name: 'Rating', icon: 'ri-star-half-line', category: 'UI', defaultProps: { value: 4, max: 5, color: '#F59E0B' } },
  { id: 'progress', name: 'Progress Bar', icon: 'ri-progress-4-line', category: 'UI', defaultProps: { value: 65, color: '#14B8A6', backgroundColor: '#E5E7EB', height: 8 } },
  { id: 'countdown', name: 'Countdown Timer', icon: 'ri-timer-line', category: 'UI', defaultProps: { targetDate: '2025-12-31', showDays: true, showHours: true, showMinutes: true, showSeconds: true, color: '#14B8A6' } },
  { id: 'notificationbanner', name: 'Notification Banner', icon: 'ri-notification-badge-line', category: 'UI', defaultProps: { message: 'Important notification message', type: 'info', dismissible: true, icon: 'ri-information-line' } },
  { id: 'qrcode', name: 'QR Code', icon: 'ri-qr-code-line', category: 'UI', defaultProps: { data: 'https://yourappwizard.net', size: 120, backgroundColor: '#FFFFFF', foregroundColor: '#000000' } },
  { id: 'chart', name: 'Chart', icon: 'ri-bar-chart-line', category: 'UI', defaultProps: { type: 'bar', title: 'Monthly Stats', data: [65, 78, 90, 81, 56, 72], labels: ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun'], color: '#14B8A6' } },
  // Forms
  { id: 'input', name: 'Text Input', icon: 'ri-input-field', category: 'Forms', defaultProps: { placeholder: 'Enter text...', label: 'Label', type: 'text' } },
  { id: 'search', name: 'Search Bar', icon: 'ri-search-line', category: 'Forms', defaultProps: { placeholder: 'Search...', backgroundColor: '#F3F4F6' } },
  { id: 'checkbox', name: 'Checkbox', icon: 'ri-checkbox-line', category: 'Forms', defaultProps: { label: 'I agree to terms', checked: false } },
  { id: 'toggle', name: 'Toggle', icon: 'ri-toggle-line', category: 'Forms', defaultProps: { label: 'Enable notifications', enabled: true, color: '#14B8A6' } },
  { id: 'dropdown', name: 'Dropdown', icon: 'ri-arrow-down-s-line', category: 'Forms', defaultProps: { options: ['Option 1', 'Option 2', 'Option 3'], placeholder: 'Select an option' } },
  { id: 'loginform', name: 'Login Form', icon: 'ri-login-box-line', category: 'Forms', defaultProps: { title: 'Sign In', showSocial: true, buttonColor: '#14B8A6' } },
  { id: 'signupform', name: 'Signup Form', icon: 'ri-user-add-line', category: 'Forms', defaultProps: { title: 'Create Account', showSocial: true, buttonColor: '#14B8A6' } },
  { id: 'paymentform', name: 'Payment Form', icon: 'ri-bank-card-line', category: 'Forms', defaultProps: { title: 'Payment Details', showSavedCards: true, buttonColor: '#14B8A6' } },
  // Navigation
  { id: 'header', name: 'App Header', icon: 'ri-navigation-line', category: 'Navigation', defaultProps: { title: 'My App', showBack: false, backgroundColor: '#FFFFFF', showMenu: true } },
  { id: 'tabbar', name: 'Tab Bar', icon: 'ri-layout-bottom-2-line', category: 'Navigation', defaultProps: { tabs: ['Home', 'Search', 'Cart', 'Profile'], activeTab: 0, color: '#14B8A6' } },
  { id: 'breadcrumb', name: 'Breadcrumb', icon: 'ri-arrow-right-s-line', category: 'Navigation', defaultProps: { items: ['Home', 'Category', 'Item'] } },
  // Media
  { id: 'video', name: 'Video Player', icon: 'ri-video-line', category: 'Media', defaultProps: { thumbnail: 'https://readdy.ai/api/search-image?query=video%20thumbnail%20modern%20app%20interface%20clean%20design&width=400&height=225&seq=video-thumb-001&orientation=landscape', title: 'Video Title', duration: '5:32' } },
  { id: 'map', name: 'Map View', icon: 'ri-map-pin-2-line', category: 'Media', defaultProps: { address: 'New York, NY', zoom: 14, showMarker: true } },
  { id: 'carousel', name: 'Carousel', icon: 'ri-slideshow-3-line', category: 'Media', defaultProps: { count: 3, autoplay: true } },
  { id: 'onboarding', name: 'Onboarding Slider', icon: 'ri-slideshow-4-line', category: 'Media', defaultProps: { slides: 3, currentSlide: 0, showSkip: true, color: '#14B8A6' } },
  { id: 'socialshare', name: 'Social Share Bar', icon: 'ri-share-line', category: 'Media', defaultProps: { platforms: ['facebook', 'twitter', 'instagram', 'whatsapp'], title: 'Share this', color: '#14B8A6' } },
  { id: 'imageupload', name: 'Image Upload', icon: 'ri-upload-cloud-2-line', category: 'Media', defaultProps: { label: 'Upload Image', hint: 'Tap to choose a photo', allowMultiple: false, showPreview: true, uploadedSrc: '', borderRadius: 12, height: 140 } },
  // Lists
  { id: 'list', name: 'List Item', icon: 'ri-list-check', category: 'Lists', defaultProps: { title: 'List Item', subtitle: 'Subtitle text', showArrow: true, showIcon: true, iconName: 'ri-star-line', iconColor: '#14B8A6' } },
  { id: 'productcard', name: 'Product Card', icon: 'ri-shopping-bag-line', category: 'Lists', defaultProps: { name: 'Product Name', price: '$29.99', originalPrice: '$49.99', rating: 4.5, badge: 'Sale' } },
  { id: 'usercard', name: 'User Card', icon: 'ri-user-line', category: 'Lists', defaultProps: { name: 'John Doe', role: 'Designer', followers: '2.4k' } },
  { id: 'notification', name: 'Notification', icon: 'ri-notification-3-line', category: 'Lists', defaultProps: { title: 'New message', body: 'You have a new message from Sarah', time: '2m ago', unread: true } },
];

export const categories = ['Layout', 'UI', 'Forms', 'Navigation', 'Media', 'Lists'];

interface ComponentLibraryProps {
  onDragStart: (e: React.DragEvent, component: ComponentItem) => void;
  onAddComponent: (component: ComponentItem) => void;
}

export default function ComponentLibraryPanel({ onDragStart, onAddComponent }: ComponentLibraryProps) {
  const [search, setSearch] = useState('');
  const [collapsed, setCollapsed] = useState<Set<string>>(new Set());

  const filtered = componentLibrary.filter(
    (c) =>
      c.name.toLowerCase().includes(search.toLowerCase()) ||
      c.category.toLowerCase().includes(search.toLowerCase())
  );

  const grouped = categories.reduce((acc, cat) => {
    acc[cat] = filtered.filter((c) => c.category === cat);
    return acc;
  }, {} as Record<string, ComponentItem[]>);

  const toggle = (cat: string) => {
    const next = new Set(collapsed);
    next.has(cat) ? next.delete(cat) : next.add(cat);
    setCollapsed(next);
  };

  return (
    <div className="flex flex-col h-full overflow-hidden">
      <div className="p-3 border-b border-gray-100">
        <div className="relative">
          <i className="ri-search-line absolute left-3 top-1/2 -translate-y-1/2 text-gray-400 text-sm"></i>
          <input
            type="text"
            placeholder="Search components..."
            value={search}
            onChange={(e) => setSearch(e.target.value)}
            className="w-full pl-8 pr-3 py-2 text-xs border border-gray-200 rounded-lg focus:border-teal-400 focus:ring-1 focus:ring-teal-400/20 outline-none bg-gray-50"
          />
        </div>
      </div>
      <div className="flex-1 overflow-y-auto">
        {categories.map((cat) => {
          const items = grouped[cat];
          if (!items || items.length === 0) return null;
          const isCollapsed = collapsed.has(cat);
          return (
            <div key={cat} className="border-b border-gray-100">
              <button
                onClick={() => toggle(cat)}
                className="w-full px-3 py-2.5 flex items-center justify-between hover:bg-gray-50 transition-colors cursor-pointer"
              >
                <span className="text-xs font-bold text-gray-500 uppercase tracking-wider">{cat}</span>
                <i className={`ri-arrow-${isCollapsed ? 'down' : 'up'}-s-line text-gray-400 text-sm`}></i>
              </button>
              {!isCollapsed && (
                <div className="px-2 pb-2 grid grid-cols-2 gap-1.5">
                  {items.map((comp) => (
                    <div
                      key={comp.id}
                      draggable
                      onDragStart={(e) => onDragStart(e, comp)}
                      onClick={() => onAddComponent(comp)}
                      className="group p-2.5 bg-gray-50 hover:bg-teal-50 border border-gray-200 hover:border-teal-300 rounded-lg cursor-grab active:cursor-grabbing transition-all"
                    >
                      <div className="w-8 h-8 flex items-center justify-center bg-white rounded-md mb-1.5 group-hover:bg-teal-100 transition-colors border border-gray-100">
                        <i className={`${comp.icon} text-base text-gray-500 group-hover:text-teal-600`}></i>
                      </div>
                      <span className="text-xs font-medium text-gray-600 group-hover:text-teal-700 leading-tight block">{comp.name}</span>
                    </div>
                  ))}
                </div>
              )}
            </div>
          );
        })}
      </div>
    </div>
  );
}